<div class="wrapper">
  <div class="maxwidth">
    <h4 class="title tipo-second-color bold center">{{ 'SUPER-ADMIN.CLIENT.COMPANY-HIRING.TITLE' | translate }}</h4>
    <!-- Datos de contratación -->
    <div class="back-white-color box_title">
      <h4 class="subtitle tipo-second-color regular center">
        {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.TITLE-DATA-HIRING' | translate }}
      </h4>
    </div>
    <div class="box-container">
      <div class="box">
        <form [formGroup]="dataHiring">
          <div class="form">
            <div class="row">
              <div class="input">
                <label for="doctorsAmountId">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.LABEL-PROFESSIONALS' | translate }}
                </label>
                <select
                  formControlName="doctorsAmountId"
                  id="doctorsAmountId"
                  [ngClass]="{ wrong: shouldShowError(dataHiring, 'doctorsAmountId') }">
                  @for (doctors of doctorsAmounts; track doctors) {
                    <option [ngValue]="doctors.id">
                      {{ doctors.name }}
                    </option>
                  }
                </select>
              </div>
              @if (this.dataHiring.get('doctorsAmountId')?.errors?.['required'] && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.MESSAGE-ERROR-PROFESSIONALS' | translate }}
                </p>
              }

              <div class="input">
                <label for="billingTypeId">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.LABEL-PAYMENT' | translate }}
                </label>
                <select
                  formControlName="billingTypeId"
                  id="billingTypeId"
                  [ngClass]="{ wrong: shouldShowError(dataHiring, 'billingTypeId') }">
                  @for (billing of billingTypes; track billing) {
                    <option [ngValue]="billing.id">{{ billing.name }}</option>
                  }
                </select>
              </div>
              @if (this.dataHiring.get('billingTypeId')?.errors?.['required'] && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.MESSAGE-ERROR-PAYMENT' | translate }}
                </p>
              }

              <div class="input">
                <label for="paymentMethodTypeId">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.LABEL-MODE' | translate }}
                </label>
                <select
                  formControlName="paymentMethodTypeId"
                  id="paymentMethodTypeId"
                  (change)="checkSepa()"
                  [ngClass]="{ wrong: shouldShowError(dataHiring, 'paymentMethodTypeId') }">
                  @for (method of paymentMethodTypes; track method) {
                    <option [ngValue]="method.id">
                      {{ method.name }}
                    </option>
                  }
                </select>
              </div>
              @if (this.dataHiring.get('paymentMethodTypeId')?.errors?.['required'] && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.MESSAGE-ERROR-MODE' | translate }}
                </p>
              }

              <div class="input">
                <label for="registryTypeId">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.LABEL-TYPE' | translate }}
                </label>
                <select
                  formControlName="registryTypeId"
                  id="registryTypeId"
                  (change)="checkHis()"
                  [ngClass]="{ wrong: shouldShowError(dataHiring, 'registryTypeId') }">
                  @for (type of registryTypes; track type) {
                    <option [ngValue]="type.id">{{ type.name }}</option>
                  }
                </select>
              </div>
              @if (this.dataHiring.get('registryTypeId')?.errors?.['required'] && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.MESSAGE-ERROR-TYPE' | translate }}
                </p>
              }
              @if (isHis) {
                <div class="input">
                  <label for="his">{{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.LABEL-HIS' | translate }}</label>
                  <input
                    type="text"
                    id="nameHis"
                    formControlName="his"
                    [ngClass]="{ wrong: shouldShowError(dataHiring, 'his') }" />
                </div>
              }
              @if (this.dataHiring.get('his')?.errors?.['required'] && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.MESSAGE-ERROR-HIS' | translate }}
                </p>
              }
            </div>

            <div class="row">
              <div class="input">
                <label for="price">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.LABEL-AMOUNT' | translate }}
                </label>
                <input
                  type="text"
                  id="price"
                  formControlName="price"
                  [ngClass]="{ wrong: shouldShowError(dataHiring, 'price') }" />
              </div>
              @if (
                (this.dataHiring.get('price')?.errors?.['required'] ||
                  this.dataHiring.get('price')?.errors?.['pattern']) &&
                this.isSubmit
              ) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.MESSAGE-ERROR-AMOUNT' | translate }}
                </p>
              }

              <div class="input">
                <label for="suscriptionsTypeId">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.LABEL-SUSCRIPTION' | translate }}
                </label>
                <select
                  formControlName="subscriptionsTypeId"
                  id="subscriptionsTypeId"
                  [ngClass]="{ wrong: shouldShowError(dataHiring, 'subscriptionsTypeId') }"
                  multiple>
                  @for (type of subscriptionTypes; track type) {
                    <option [ngValue]="type.id">{{ type.name }}</option>
                  }
                </select>
              </div>
              <p class="small">{{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.MESSAGE-ABVICE-SUSCRIPTION' | translate }}</p>
              @if (this.dataHiring.get('subscriptionsTypeId')?.errors?.['required'] && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.MESSAGE-ERROR-SUSCRIPTION' | translate }}
                </p>
              }

              @if (isSepa) {
                <div class="input">
                  <label for="bankAccount">
                    {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.LABEL-SEPA' | translate }}
                  </label>
                  <input
                    type="text"
                    id="bankAccount"
                    formControlName="bankAccount"
                    [ngClass]="{ wrong: shouldShowError(dataHiring, 'bankAccount') }" />
                </div>
              }
              @if (this.dataHiring.get('bankAccount')?.errors?.['required'] && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.MESSAGE-ERROR-SEPA' | translate }}
                </p>
              }

              @if (!isHis) {
                <div class="input">
                  <label for="signaturesAmountId">
                    {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.LABEL-SIGNS' | translate }}
                  </label>
                  <select
                    formControlName="signaturesAmountId"
                    id="signaturesAmountId"
                    [ngClass]="{ wrong: shouldShowError(dataHiring, 'signaturesAmountId') }">
                    @for (signature of signaturesAmounts; track signature) {
                      <option [ngValue]="signature.id">{{ signature.name }}</option>
                    }
                  </select>
                </div>
              }
              @if (this.dataHiring.get('signaturesAmountId')?.errors?.['required'] && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.MESSAGE-ERROR-SIGNS' | translate }}
                </p>
              }

              <div class="input">
                <label class="speciality" for="selected">
                  {{ 'PRIVATE.DOCTOR.DATA-DOCTOR.SPECIALTY' | translate }}
                </label>

                <div class="specialties_input">
                  <div class="specialties">
                    @for (item of specialty; track item; let i = $index) {
                      <span class="selected">
                        {{ item.name }}
                        <fa-icon [icon]="faCircleXmark" class="icono" (click)="deleteItem(i, item)"></fa-icon>
                      </span>
                    }
                  </div>
                  <ul class="specialty_select" (click)="editField()" (keydown)="editField()" [ngClass]="{ wrong: shouldShowError(dataHiring, 'specialtiesId') }">
                    @for (specialty of specialties; track specialty; let i = $index) {
                      <li value="{{ specialty.id }}" (click)="addItem(i, specialty)">
                        {{ specialty.name }}
                      </li>
                    }
                  </ul>
                </div>
              </div>
              @if (this.dataHiring.get('specialtiesId')?.errors?.['required'] && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.MESSAGE-FIELD-SPECIALTY' | translate }}
                </p>
              }
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Datos de acceso -->
    <div class="back-white-color box_title">
      <h4 class="subtitle tipo-second-color regular center">
        {{ 'SUPER-ADMIN.CLIENT.DATA-ACCESS.TITLE-DATA-ACCESS' | translate }}
      </h4>
    </div>
    <div class="box-container">
      <div class="box">
        <form [formGroup]="dataAccess">
          <div class="form">
            <div class="row">
              <div class="input">
                <label for="username">*{{ 'SUPER-ADMIN.CLIENT.DATA-ACCESS.LABEL-USER' | translate }}</label>
                <input
                  type="text"
                  id="username"
                  formControlName="username"
                  [ngClass]="{ wrong: shouldShowError(dataAccess, 'username') }" />
              </div>
              @if (
                (this.dataAccess.get('username')?.errors?.['required'] ||
                  this.dataAccess.get('username')?.errors?.['invalidDocument'] ||
                  this.dataAccess.get('username')?.errors?.['minlength']) &&
                this.isSubmit
              ) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-ACCESS.MESSAGE-ERROR-USER' | translate }}
                </p>
              }

              <div class="input">
                <label for="password">*{{ 'SUPER-ADMIN.CLIENT.DATA-ACCESS.LABEL-PASSWORD' | translate }}</label>
                <input
                  type="password"
                  id="password"
                  formControlName="password"
                  [ngClass]="{ wrong: shouldShowError(dataAccess, 'password') }" />
              </div>
              @if (
                (this.dataAccess.get('password')?.errors?.['required'] ||
                  this.dataAccess.get('password')?.errors?.['minLengthPassword']) &&
                this.isSubmit
              ) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-ACCESS.MESSAGE-ERROR-PASS' | translate }}
                </p>
              }
            </div>
            <div class="row">
              <div class="input">
                <label for="countryId tipo-main-color regular">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-ACCESS.LABEL-COUNTRY' | translate }}
                </label>
                <select
                  formControlName="countryId"
                  id="country"
                  [ngClass]="{ wrong: shouldShowError(dataAccess, 'countryId') }">
                  @for (country of countries; track country; let i = $index) {
                    <option [ngValue]="country.id">{{ country.name }}</option>
                  }
                </select>
              </div>
              @if (this.dataAccess.get('countryId')?.errors?.['required'] && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-ACCESS.MESSAGE-ERROR-COUNTRY' | translate }}
                </p>
              }
              <div class="input">
                <label for="repeat_pass">
                  *{{ 'SUPER-ADMIN.CLIENT.DATA-ACCESS.LABEL-REPEAT-PASSWORD' | translate }}
                </label>
                <input
                  type="password"
                  id="repeat_pass"
                  formControlName="repeatPass"
                  [ngClass]="{ wrong: shouldShowError(dataAccess, 'repeatPass') }" />
              </div>
              @if (this.dataAccess.errors?.['passwordsNotMatching'] && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-ACCESS.MESSAGE-ERROR-PASS-DOUBLE' | translate }}
                </p>
              }
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Datos de empresa -->
    <div class="back-white-color box_title">
      <h4 class="subtitle tipo-second-color regular center">
        {{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.TITLE-DATA-COMPANY' | translate }}
      </h4>
    </div>
    <div class="box-container">
      <div class="box">
        <form [formGroup]="dataCompany">
          <div class="form">
            <div class="row">
              <div class="input">
                <label for="company_name">
                  *{{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.LABEL-COMPANY-NAME' | translate }}
                </label>
                <input
                  type="text"
                  id="company_name"
                  formControlName="businessName"
                  [ngClass]="{ wrong: shouldShowError(dataCompany, 'businessName') }" />
              </div>
              @if ((this.dataCompany.get('businessName')?.errors?.['required'] ||
                  this.dataCompany.get('businessName')?.errors?.['invalidField']) && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.MESSAGE-ERROR-COMPANY-NAME' | translate }}
                </p>
              }
              <div class="input">
                <label for="privacy_url">{{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.LABEL-PRIVACY-URL' | translate }}</label>
                <input type="text" id="privacy_url" formControlName="website" 
                [ngClass]="{ wrong: shouldShowError(dataCompany, 'website') }"/>
                <span class="small tipo-second-color">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.MESSAGE-URL' | translate }}
                </span>
              </div>
               @if (this.dataCompany.get('website')?.errors?.['invalidField']) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.INVALID-WEBSITE' | translate }}
                </p>
              }
              <div class="input">
                <label for="agent">{{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.LABEL-AGENT' | translate }}</label>
                <input type="text" id="agent" formControlName="name" 
                [ngClass]="{ wrong: shouldShowError(dataCompany, 'name') }"/>
              </div>
                @if (this.dataCompany.get('name')?.errors?.['invalidName']) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.MESSAGE-ERROR-AGENT' | translate }}
                </p>
              }
              <div class="input">
                <label for="email">{{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.LABEL-EMAIL-AGENT' | translate }}</label>
                <input type="email" id="email" formControlName="email" 
                [ngClass]="{ wrong: shouldShowError(dataCompany, 'email') }" />
              </div>
               @if (this.dataCompany.get('email')?.errors?.['invalidEmail'] && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SHARED.INVALID-EMAIL' | translate }}
                </p>
              }
            </div>
            <div class="row">
              <div class="input">
                <label for="document">*{{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.LABEL-DOCUMENT' | translate }}</label>
                <input
                  type="text"
                  id="document"
                  formControlName="cif"
                  [ngClass]="{ wrong: shouldShowError(dataCompany, 'cif') }" />
                <span class="small tipo-second-color">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.MESSAGE-DOCUMENT' | translate }}
                </span>
              </div>
              @if ((this.dataCompany.get('cif')?.errors?.['required'] || this.dataCompany.get('cif')?.errors?.['invalidDocument']) && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.MESSAGE-ERROR-DOCUMENT' | translate }}
                </p>
              }
              <div class="space"></div>
              <div class="input">
                <label for="document_agent">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.LABEL-DOCUMENT-AGENT' | translate }}
                </label>
                <input
                  type="text"
                  id="document_agent"
                  formControlName="dniCif"
                  [ngClass]="{ wrong: shouldShowError(dataCompany, 'dniCif') }" />
              </div>
              @if (this.dataCompany.get('dniCif')?.errors?.['invalidDocument'] && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.MESSAGE-ERROR-DOCUMENT' | translate }}
                </p>
              }

              <div class="input">
                <label for="mobile">{{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.LABEL-PHONE-AGENT' | translate }}</label>
                <input
                  type="tel"
                  id="mobile"
                  formControlName="mobile"
                  [ngClass]="{ wrong: shouldShowError(dataCompany, 'mobile') }" />
              </div>
              @if (this.dataCompany.get('mobile')?.errors?.['invalidPhone'] && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.MESSAGE-ERROR-PHONE-AGENT' | translate }}
                </p>
              }
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Datos de contacto -->
    <div class="back-white-color box_title">
      <h4 class="subtitle tipo-second-color regular center">
        {{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.TITLE-DATA-CONTACT' | translate }}
      </h4>
    </div>
    <div class="box-container">
      <div class="box">
        <form [formGroup]="dataContact">
          <div class="form">
            <div class="row">
              <div class="input">
                <label for="address">*{{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.LABEL-ADDRESS' | translate }}</label>
                <input
                  type="text"
                  id="address"
                  formControlName="address"
                  [ngClass]="{ wrong: shouldShowError(dataContact, 'address') }" />
              </div>
              @if ((this.dataContact.get('address')?.errors?.['required'] || this.dataContact.get('address')?.errors?.['invalidAddress'] ) && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.MESSAGE-ERROR-ADDRESS' | translate }}
                </p>
              }

              <div class="input">
                <label for="postal_code">*{{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.LABEL-POSTAL-CODE' | translate }}</label>
                <input
                  type="text"
                  id="postal_code"
                  formControlName="postCode"
                  [ngClass]="{ wrong: shouldShowError(dataContact, 'postCode') }" />
              </div>
              @if ((this.dataContact.get('postCode')?.errors?.['invalidPostcode'] ||
                  this.dataContact.get('postCode')?.errors?.['required']) && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.MESSAGE-ERROR-POSTAL-CODE' | translate }}
                </p>
              }
              <div class="input">
                <label for="email_company">*{{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.LABEL-EMAIL' | translate }}</label>
                <input
                  type="email"
                  id="email_company"
                  formControlName="email"
                  [ngClass]="{ wrong: shouldShowError(dataContact, 'email') }" />
              </div>
              @if ((this.dataContact.get('email')?.errors?.['invalidEmail'] ||
                  this.dataContact.get('email')?.errors?.['required']) && this.isSubmit ) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.MESSAGE-ERROR-EMAIL-AGENT' | translate }}
                </p>
              }
              <div class="input">
                <label for="second_phone">{{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.LABEL-SECOND-PHONE' | translate }}</label>
                <input type="tel" id="second_phone" formControlName="phone" />
                <span class="small tipo-second-color">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.MESSAGE-ERROR-MOBILE' | translate }}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="input">
                <label for="locality">*{{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.LABEL-CITY' | translate }}</label>
                <input
                  type="text"
                  id="locality"
                  formControlName="locality"
                  [ngClass]="{ wrong: shouldShowError(dataContact, 'locality') }" />
              </div>
              @if ((this.dataContact.get('locality')?.errors?.['required'] || this.dataContact.get('locality')?.errors?.['invalidField']) && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.MESSAGE-ERROR-CITY' | translate }}
                </p>
              }

              <div class="input">
                <label for="stateId">*{{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.LABEL-PROVINCE' | translate }}</label>
                <select
                  formControlName="stateId"
                  id="stateId"
                  [ngClass]="{ wrong: shouldShowError(dataContact, 'stateId') }">
                  @for (state of states; track state; let i = $index) {
                    <option [ngValue]="state.id">{{ state.name }}</option>
                  }
                </select>
              </div>
              @if (this.dataContact.get('stateId')?.errors?.['required'] && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.MESSAGE-ERROR-PROVINCE' | translate }}
                </p>
              }
              <div class="input">
                <label for="mobile">*{{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.LABEL-MOBILE' | translate }}</label>
                <input
                  type="tel"
                  id="mobile"
                  formControlName="mobile"
                  [ngClass]="{ wrong: shouldShowError(dataContact, 'mobile') }" />
                <span class="small tipo-second-color">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.MESSAGE-MOBILE' | translate }}
                </span>
              </div>
              @if (
                (this.dataContact.get('mobile')?.errors?.['invalidPhone'] ||
                  this.dataContact.get('mobile')?.errors?.['required']) &&
                this.isSubmit
              ) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.MESSAGE-ERROR-MOBILE' | translate }}
                </p>
              }
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Datos de RGPD -->
    <div class="back-white-color box_title">
      <h4 class="subtitle tipo-second-color regular center">
        {{ 'SUPER-ADMIN.CLIENT.DATA-RGPD.TITLE-DATA-RGPD' | translate }}
      </h4>
    </div>
    <div class="box-container">
      <div class="box">
        <form [formGroup]="dataRgpd">
          <div class="form">
            <div class="row">
              <input type="checkbox" formControlName="copied" id="copied" />
              <label for="copied" class="small">{{ 'SUPER-ADMIN.CLIENT.DATA-RGPD.LABEL-COPIED' | translate }}</label>

              <div class="input">
                <label for="company_name_fis">
                  *{{ 'SUPER-ADMIN.CLIENT.DATA-RGPD.LABEL-COMPANY-NAME-FIS' | translate }}
                </label>
                <input
                  type="text"
                  id="company_name_fis"
                  formControlName="businessNameFis"
                  [ngClass]="{ wrong: shouldShowError(dataRgpd, 'businessNameFis') }" />
              </div>
              @if ((this.dataRgpd.get('businessNameFis')?.errors?.['required'] ||
                  this.dataRgpd.get('businessNameFis')?.errors?.['fieldValidator']) && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.MESSAGE-ERROR-COMPANY-NAME' | translate }}
                </p>
              }

              <div class="input">
                <label for="address_fis">*{{ 'SUPER-ADMIN.CLIENT.DATA-RGPD.LABEL-ADDRESS-FIS' | translate }}</label>
                <input
                  type="text"
                  id="address_fis"
                  formControlName="addressFis"
                  [ngClass]="{ wrong: shouldShowError(dataRgpd, 'addressFis') }" />
              </div>
              @if ((this.dataRgpd.get('addressFis')?.errors?.['required'] || this.dataRgpd.get('addressFis')?.errors?.['invalidAddress'] ) && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.MESSAGE-ERROR-ADDRESS' | translate }}
                </p>
              }

              <div class="input">
                <label for="postal_code_fis">
                  *{{ 'SUPER-ADMIN.CLIENT.DATA-RGPD.LABEL-POSTAL-CODE-FIS' | translate }}
                </label>
                <input
                  type="text"
                  id="postal_code_fis"
                  formControlName="postCodeFis"
                  [ngClass]="{ wrong: shouldShowError(dataRgpd, 'postCodeFis') }" />
              </div>
               @if ((this.dataRgpd.get('postCodeFis')?.errors?.['invalidPostcode'] ||
                  this.dataRgpd.get('postCodeFis')?.errors?.['required']) && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.MESSAGE-ERROR-POSTAL-CODE' | translate }}
                </p>
              }

              <div class="input">
                <label for="email_company_fis">
                  *{{ 'SUPER-ADMIN.CLIENT.DATA-RGPD.LABEL-EMAIL-RGPD' | translate }}
                </label>
                <input
                  type="email"
                  id="email_company_fis"
                  formControlName="emailLOPD"
                  [ngClass]="{ wrong: shouldShowError(dataRgpd, 'emailLOPD') }" />
              </div>
              @if ((this.dataRgpd.get('emailLOPD')?.errors?.['invalidEmail'] ||
                  this.dataRgpd.get('emailLOPD')?.errors?.['required']) && this.isSubmit ) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.MESSAGE-ERROR-EMAIL-AGENT' | translate }}
                </p>
              }
            </div>
            <div class="row">
              <div class="input">
                <label for="document_fis">*{{ 'SUPER-ADMIN.CLIENT.DATA-RGPD.LABEL-DOCUMENT-FIS' | translate }}</label>
                <input
                  type="text"
                  id="document_fis"
                  formControlName="cifFis"
                  [ngClass]="{ wrong: shouldShowError(dataRgpd, 'cifFis') }" />
                <span class="small tipo-second-color">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.MESSAGE-DOCUMENT' | translate }}
                </span>
              </div>
              @if ((this.dataRgpd.get('cifFis')?.errors?.['required'] || this.dataRgpd.get('cifFis')?.errors?.['invalidDocument']) && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-COMPANY.MESSAGE-ERROR-DOCUMENT' | translate }}
                </p>
              }

              <div class="input">
                <label for="city_fis">*{{ 'SUPER-ADMIN.CLIENT.DATA-RGPD.LABEL-CITY-FIS' | translate }}</label>
                <input
                  type="text"
                  id="city_fis"
                  formControlName="localityFis"
                  [ngClass]="{ wrong: shouldShowError(dataRgpd, 'localityFis') }" />
              </div>
              @if ((this.dataRgpd.get('localityFis')?.errors?.['required'] || this.dataRgpd.get('localityFis')?.errors?.['invalidField']) && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.MESSAGE-ERROR-CITY' | translate }}
                </p>
              }

              <div class="input">
                <label for="stateIdFis">*{{ 'SUPER-ADMIN.CLIENT.DATA-RGPD.LABEL-PROVINCE-FIS' | translate }}</label>
                <select
                  formControlName="stateIdFis"
                  id="stateIdFis"
                  [ngClass]="{ wrong: shouldShowError(dataRgpd, 'stateIdFis') }">
                  @for (state of states; track state; let i = $index) {
                    <option [ngValue]="state.id">{{ state.name }}</option>
                  }
                </select>
              </div>
              @if (this.dataRgpd.get('stateIdFis')?.errors?.['required'] && this.isSubmit) {
                <p class="message_error wrongtext small">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-CONTACT.MESSAGE-ERROR-PROVINCE' | translate }}
                </p>
              }

              <div class="buttons">
                <button class="button tipo-white-color back-blue-color" (click)="onSubmit()">
                  {{ 'SUPER-ADMIN.CLIENT.DATA-HIRING.BUTTON-CONTINUE' | translate }}
                  <fa-icon [icon]="faCircleArrowRight" class="icono"></fa-icon>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    @if (dataConfirm) {
      <div class="window_back">
        <div class="window">
          <app-page6-data-confirm (closed)="dataConfirm = false"></app-page6-data-confirm>
        </div>
      </div>
    }
  </div>
</div>
